import React, {useContext, useEffect} from 'react'
import './HeaderWhite.scss'
import logo from '../assets/logo.png'
import {Button, Icon} from 'rsuite'
import SVG_Walkthrough_Arrow from "../assets/icons/walkthrough_arrow.svg";
import LanguageContext from "../contexts/LanguageContext";
import axios from "axios";
import moment from "moment-timezone";
import {useHistory} from "react-router-dom";
import Modal from 'react-responsive-modal'
import {useIntl} from "react-intl";

function HeaderWhite ({
						  shadow = true,
						  goBack = undefined,
						  overlayBack = false,
						  showNotificationsBadge = true,
						showLanguageSelector = true
}) {
	let history = useHistory();
	const intl = useIntl();
	const {language, setLanguage, unreadNotifications, setUnreadNotifications} = useContext(LanguageContext)
	const intervalSeconds = 10

	const [businessEvents, setBusinessEvents] = React.useState( [])
	const [showBusinessAppModal, setShowBusinessAppModal] = React.useState(false)


	useEffect(() => {
		let jwt = localStorage.getItem('jwt')

		let firstLaunch = localStorage.getItem('first_launch')

		if(jwt) {
			getUnseenNotification(!!firstLaunch )

			let interval = setInterval(() => {
				getUnseenNotification()
			}, intervalSeconds * 1000)

			return () => {
				clearInterval(interval)
			}
		}

		if(typeof goBack !== "undefined") {
			localStorage.removeItem('first_launch')
		}


		// eslint-disable-next-line
	}, []);

	const getUnseenNotification = async (firstLaunch = false) => {
		let jwt = localStorage.getItem('jwt')


		if(jwt) {

			let notificationsCheckDate = localStorage.getItem('notifications_check_date')
			if(notificationsCheckDate && notificationsCheckDate.length > 6) {
				//Compare dates
				let duration = moment.duration(moment().diff(moment(notificationsCheckDate)))
				if(duration.asSeconds() < intervalSeconds) {
					return
				}
			}

			localStorage.setItem('notifications_check_date', moment().toISOString())

			let auth = {
				headers: {
					'Authorization': 'Bearer ' + localStorage.getItem('jwt'),
					'App-Type': process.env.REACT_APP_TYPE
				}
			}

			axios.get(process.env.REACT_APP_DOMAIN + 'notifications/unseen_notifications_count', auth)
				.then(response => {
					if(response && response.data && response.data.status === 1) {
						if(unreadNotifications !== response.data.unseen_notifications_count) {
							setUnreadNotifications(response.data.unseen_notifications_count)
						}

						if(process.env.REACT_APP_DOMAIN == 'https://admin.ality.ro/') {
							if (response.data.frontend_version && response.data.frontend_version !== 'unknown') {
								const shouldForceRefresh = semverGreaterThan(response.data.frontend_version, global.appVersion);
								if (shouldForceRefresh) {
									if (caches) {
										// Service worker cache should be cleared with caches.delete()
										caches.keys().then(function (names) {
											for (let name of names) caches.delete(name);
										});
									}
									// delete browser cache and hard reload
									window.location.reload(true);
								} else {

								}
							}
						}

						if(firstLaunch && process.env.REACT_APP_TYPE === 'invites' && response.data.active_business_events && response.data.active_business_events[0] && response.data.active_business_events[0].title) {
							setBusinessEvents(response.data.active_business_events)
							setShowBusinessAppModal(true)
						}
					}
				})
		}
	}

	const semverGreaterThan = (versionA, versionB) => {

		versionA = parseInt(versionA.replaceAll('.',''))
		versionB = parseInt(versionB.replaceAll('.',''))

		return versionA > versionB
	}

	const getMobileOperatingSystem = () => {
		var userAgent = navigator.userAgent || navigator.vendor || window.opera;

		// Windows Phone must come first because its UA also contains "Android"
		if (/windows phone/i.test(userAgent)) {
			return "Windows Phone";
		}

		if (/android/i.test(userAgent)) {
			return "Android";
		}

		// iOS detection from: http://stackoverflow.com/a/9039885/177710
		if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
			return "iOS";
		}

		return "unknown";
	}

	return (<div style={!shadow ? {boxShadow: "none" } : {}} className="HeaderWhite-container">
		<div className="HeaderWhite-contents">
			<div className="with-back">

				{
					overlayBack ?
						<>

							{goBack !== undefined &&
								<Icon onClick={goBack} icon="angle-left" className={"walkthrough-over-icon"} style={{ position: "absolute", left: "50px", cursor:"pointer", }} />}

							<div className={"walkthrough-over-arrow"}>
								<img  alt={""} src={SVG_Walkthrough_Arrow}/>
							</div>

						</>
						:<>
							{goBack !== undefined &&
								<Icon onClick={goBack} icon="angle-left" style={{ position: "absolute", left: "50px", cursor:"pointer", }} />}

						</>
				}




				<img src={logo} style={{ height: "50px" }} alt="logo" />


				{showNotificationsBadge ?
				<div className={"notifications-cont"}>
					<div className={"notifications-cont-inner"} onClick={() => history.push('/notifications')}>
					<img src={"/images/icons/bell.svg"} style={{width:'25px'}} alt={"notifications"}/>
						{unreadNotifications > 0 ?
							<div className={"notification-unread-count"}>{unreadNotifications}</div>
						:null}
					</div>
				</div>:null}

				{goBack !== undefined && <div></div>}
				{
					showLanguageSelector ?
					language === 'ro' ?
						<img  alt={""} src={"/images/languages/en.png"} onClick={() => setLanguage('en')} style={{cursor:"pointer", position: "absolute", marginTop:"8px", right: "30px", width:"30px" }}/>
						:
						<img  alt={""} src={"/images/languages/ro.png"} onClick={() => setLanguage('ro')} style={{cursor:"pointer", position: "absolute", marginTop:"8px", right: "30px", width:"30px" }}/>
					:null
				}

			</div>
		</div>


		{showBusinessAppModal ?
			<Modal
				classNames={{
					overlay: 'modal-overlay',
					modal: 'modal',
					closeButton: 'modal-close-button',
				}}
				open={showBusinessAppModal && businessEvents && businessEvents[0] && businessEvents[0].title}
				focusTrapped={false}
				onClose={() => setShowBusinessAppModal(false)}
				closeOnOverlayClick={false}
			>
				<div style={{marginTop: "20px", textAlign: 'center'}}>

					{language === 'ro' ?
						<>
						 <h4>Cauți evenimentul <strong style={{color:'green'}}>{businessEvents ? businessEvents[0].title : ''}?</strong></h4>
							<p style={{marginTop:'15px'}}>
								Începând cu ianuarie 2026, aplicația Ality s-a împărțit în două aplicații separate: <strong>Ality - Planner Events</strong>, dedicată evenimentelor private + invitațiilor digitale și <strong>Ality - Business Events</strong>, destinată evenimentelor mari, precum baluri, ceremonii sau conferințe.

								<br/><br/>
								Pentru a putea accesa evenimentul <strong style={{color:'green'}}>{businessEvents ? businessEvents[0].title : ''}</strong> sau alte evenimente similare la care participi, te rugăm să descarci/accesezi aplicația <strong>Ality – Business Events</strong>.
							</p>
						</>
						:
						<>
							<>
								<h4>
									Looking for the event{" "}
									<strong style={{ color: "green" }}>
										{businessEvents ? businessEvents[0].title : ""}
									</strong>
									?
								</h4>

								<p style={{ marginTop: "15px" }}>
									Starting January 2026, the Ality app has been split into two separate
									applications: <strong>Ality – Planner Events</strong>, designed for private
									events and digital invitations, and{" "}
									<strong>Ality – Business Events</strong>, created for large-scale events such
									as balls, ceremonies, or conferences.
									<br />
									<br />
									To access the event{" "}
									<strong style={{ color: "green" }}>
										{businessEvents ? businessEvents[0].title : ""}
									</strong>{" "}
									or other similar events you are attending, please download/access the{" "}
									<strong>Ality – Business Events</strong> app.
								</p>
							</>

						</>}

					{getMobileOperatingSystem() === 'iOS' ?
						<>
							<a href={"https://apps.apple.com/ro/app/ality-business-events/id6756013017"}>
								<Button color="green" style={{
									marginTop: "20px",
									backgroundColor: "#05AFF2",
									borderRadius: "20px",
									width: "100%"
								}}>{intl.formatMessage({id: 'business_events_modal.go_to_the_new_app'})}</Button>
							</a>
						</>
						: getMobileOperatingSystem() === 'Android' ?
							<>
								<a href={"https://play.google.com/store/apps/details?id=com.creative.ality.events"}>
									<Button color="green" style={{
										marginTop: "20px",
										backgroundColor: "#05AFF2",
										borderRadius: "20px",
										width: "100%"
									}}>{intl.formatMessage({id: 'business_events_modal.go_to_the_new_app'})}</Button>
								</a>
							</>
							:
							<>
								<Button onClick={() => {
									window.location = 'https://evenimente.ality.ro'
								}} color="green" style={{
									marginTop: "20px",
									backgroundColor: "#05AFF2",
									borderRadius: "20px",
									width: "100%"
								}}>{intl.formatMessage({id: 'business_events_modal.go_to_the_new_app'})}</Button>
							</>}



				</div>
			</Modal>
		:null}

	</div>)

}

export default HeaderWhite;
